import axios from 'axios';
var localForage = require('localforage');

export default {
    install: function (Vue) {
        // definisco un oggetto $http a livello globale
        Object.defineProperty(Vue.prototype, '$http', {value: axios});
        //
        // impostazione axios
        //
        axios.defaults.headers.common['Content-Type'] = 'application/json;charset=utf-8';
        axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
        axios.defaults.headers.get['Content-Type'] = 'application/json;charset=utf-8';
        axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
        axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
        axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
        /**
         * Creazione della risposta
         * @param response
         * @param resolve
         * @param reject
         * @param token
         * @param redirectUnauthorized
         */
        const buildResponse = (response, resolve, reject, user, redirectUnauthorized) => {
            // se passo il token, arrivo dalla login e quindi
            // salvo il token
            if(user && user.token && user.token !== '') {
                localStorage.setItem('token', user.token);
                let signature = localStorage.getItem('signature') || '';
                if(signature.toLowerCase().trim() != user.email.toLowerCase().trim()) {
                    localForage.clear(() => {});
                }
                localStorage.setItem('signature', user.email);
                localStorage.setItem('user_id', user.id);
            }
            // se tutto è ok, creo la risposta
            if (response && response.data && response.status && response.status == 200) {
                if(user && user.token && user.token !== '') {
                    resolve({
                        success: true,
                    });
                }
                resolve({
                    success: true,
                    data: response.data
                });
            }
            // se ci sono stati degli errori produco la risposta di errore
            if (response && response.data && response.data.errors && response.status != 200) {
                if((response.status == 401 || response.status == 500) &&
                    (response.data.errors == "unauthorized" || response.data.errors == "token-expired") &&
                    redirectUnauthorized) {
                    // location.href = `/login?redirectFrom=${location.pathname}`;
                    location.href = `/`;
                }
                reject({
                    success: false,
                    error: response.data.errors
                });
            }
            // in altri eventuali casi
            reject({
                success: false,
                error: 'general-error'
            });
        };

        //
        // definizione delle api
        //
        const api = {
            /**
             * Login piattaform
             * @param email
             * @param password
             * @returns {Promise<any>}
             */
            login(email, password) {
                return new Promise((resolve, reject) => {
                    localStorage.removeItem('token');
                    localStorage.removeItem('profile');
                    axios.post(`${process.env.VUE_APP_API_URL}/auth/login`, {
                        email: email.trim().toLowerCase(),
                        password: password.trim().toLowerCase()
                    }, {
                        validateStatus: () => {
                            return true;
                        }
                    }).catch((errors) => {
                        reject({
                            success: false,
                            error: errors
                        });
                    }).then((result) => {
                        localStorage.setItem('users', JSON.stringify(result.data.users));
                        buildResponse(result, resolve, reject, { token: result.data.token, email: email, id: result.data.id });
                    });
                });
            },
            /**
             * Esegue una risorsa
             * @param resource - la path della risorsa
             * @param data - in formato oggetto tutti i parametri della risorsa
             * @param redirectIfUnauthorized - true/false indica se si viene rediretti alla fase di login
             * @returns {Promise<unknown>}
             */
            get(resource, data, redirectIfUnauthorized) {
                redirectIfUnauthorized = redirectIfUnauthorized || false;
                let token = localStorage.getItem('token');
                return new Promise((resolve, reject) => {
                    axios.get(`${process.env.VUE_APP_API_URL}${resource}`, {
                        params: data,
                        validateStatus: () => {
                            return true;
                        },
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }).catch((errors) => {
                        reject({
                            success: false,
                            error: errors
                        });
                    }).then((result) => {
                        buildResponse(result, resolve, reject, null, redirectIfUnauthorized);
                    });
                });
            },
            /**
             * Nuovo inserimento di una risorsa
             * @param resource
             * @param data
             * @param redirectIfUnauthorized
             * @returns {Promise<unknown>}
             */
            post(resource, data, redirectIfUnauthorized) {
                redirectIfUnauthorized = redirectIfUnauthorized || false;
                let token = localStorage.getItem('token');
                return new Promise((resolve, reject) => {
                    axios.post(`${process.env.VUE_APP_API_URL}${resource}`, data ,{
                        validateStatus: () => {
                            return true;
                        },
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }).catch((errors) => {
                        reject({
                            success: false,
                            error: errors
                        });
                    }).then((result) => {
                        buildResponse(result, resolve, reject, null, redirectIfUnauthorized);
                    });
                });
            },
            /**
             * Modifica di una risorsa
             * @param resource
             * @param data
             * @param redirectIfUnauthorized
             * @returns {Promise<unknown>}
             */
            put(resource, data, redirectIfUnauthorized) {
                redirectIfUnauthorized = redirectIfUnauthorized || false;
                let token = localStorage.getItem('token');
                return new Promise((resolve, reject) => {
                    axios.put(`${process.env.VUE_APP_API_URL}${resource}`, data ,{
                        validateStatus: () => {
                            return true;
                        },
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }).catch((errors) => {
                        reject({
                            success: false,
                            error: errors
                        });
                    }).then((result) => {
                        buildResponse(result, resolve, reject, null, redirectIfUnauthorized);
                    });
                });
            },
            /**
             * Eliminazione di una risorsa
             * @param resource
             * @param data
             * @param redirectIfUnauthorized
             * @returns {Promise<unknown>}
             */
            delete(resource, redirectIfUnauthorized) {
                redirectIfUnauthorized = redirectIfUnauthorized || false;
                let token = localStorage.getItem('token');
                return new Promise((resolve, reject) => {
                    axios.delete(`${process.env.VUE_APP_API_URL}${resource}` ,{
                        validateStatus: () => {
                            return true;
                        },
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }).catch((errors) => {
                        reject({
                            success: false,
                            error: errors
                        });
                    }).then((result) => {
                        buildResponse(result, resolve, reject, null, redirectIfUnauthorized);
                    });
                });
            }
        };
        Vue.prototype.api = api;
    }
}
